import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  inboundConsolidationAddressSchema,
  inboundConsolidationRouteEndpointSchema,
} from "./inbound-consolidation-address";
import { InboundConsolidationLifecycleStatusSchema } from "./inbound-consolidation-lifecycle";

const inboundConsolidationLineItemSchema_ = z.object({
  title: z.string(),
  productTitle: z.string(),
  sku: z.string().nullable(),
  quantity: z.number(),
  returnHref: z.string().nullable(),
});
export const inboundConsolidationLineItemSchema: z.ZodType<InboundConsolidationLineItem> =
  inboundConsolidationLineItemSchema_;
export interface InboundConsolidationLineItem extends z.infer<
  typeof inboundConsolidationLineItemSchema_
> {}

const inboundConsolidationLegSchema_ = z.object({
  sequence: z.number(),
  origin: inboundConsolidationRouteEndpointSchema,
  destination: inboundConsolidationRouteEndpointSchema,
  routeLabel: z.enum(["shared_hub", "final_mile"]),
  carrier: z.string().nullable(),
  trackingCode: z.string().nullable(),
  trackingUrl: z.string().nullable(),
});
export const inboundConsolidationLegSchema: z.ZodType<InboundConsolidationLeg> =
  inboundConsolidationLegSchema_;
export interface InboundConsolidationLeg extends z.infer<
  typeof inboundConsolidationLegSchema_
> {}

const inboundConsolidationCartonSchema_ = z.object({
  id: z.string(),
  cartonNumber: z.number(),
  legs: z.array(inboundConsolidationLegSchema),
});
export const inboundConsolidationCartonSchema: z.ZodType<InboundConsolidationCarton> =
  inboundConsolidationCartonSchema_;
export interface InboundConsolidationCarton extends z.infer<
  typeof inboundConsolidationCartonSchema_
> {}

const inboundConsolidationDetailsSchema_ = z.object({
  id: z.string(),
  reference: z.string(),
  status: InboundConsolidationLifecycleStatusSchema,
  itemCount: z.number(),
  lineItemCount: z.number(),
  batchOrigin: inboundConsolidationRouteEndpointSchema,
  batchDestination: inboundConsolidationRouteEndpointSchema,
  finalMileDestination: inboundConsolidationAddressSchema.nullable(),
  lineItems: z.array(inboundConsolidationLineItemSchema),
  cartons: z.array(inboundConsolidationCartonSchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const inboundConsolidationDetailsSchema: z.ZodType<InboundConsolidationDetails> =
  inboundConsolidationDetailsSchema_;
export interface InboundConsolidationDetails extends z.infer<
  typeof inboundConsolidationDetailsSchema_
> {}

export const getInboundConsolidationDetails = unaryRpc({
  name: "getInboundConsolidationDetails" as const,
  input: z.object({
    consolidationId: z.string(),
    itemPage: z.number().min(0).optional(),
    itemPageSize: z.number().min(1).max(200).default(25),
    includeCartons: z.boolean().optional(),
  }),
  output: inboundConsolidationDetailsSchema,
});
